import * as React from 'react';
import PlayerNextOutlined from './player-next-outlined';
import PlayerNextFilled from './player-next-filled';
import type { IconCombinedProps } from './types';
const PlayerNextCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PlayerNextFilled ref={ref} {...rest} />;
  }
  return <PlayerNextOutlined ref={ref} {...rest} />;
});
export default PlayerNextCombined;